export default "__VITE_ASSET__7aPi5AfG__"